import React from 'react';

import WrapperWidget from '../Wrapper';
import InputText from '../../../FormFields/Text';
import InputSelect from '../../../FormFields/Select';
import withFieldActions from '../withFieldActions';
import Checkbox from '../../../FormFields/Checkbox';
import UnitOptions from '../../../../Services/UnitOptions';
import Utils from '../../../../Services/Utils';
import ConfigService from "../../../../Services/api/Config";


export class UnitInfoWidget extends React.PureComponent {

  getLabel = (field) => {
    let label = 'Unit Field:';
    if (field) {
      label = field.label + ':';
    }
    return label;
  };

  handleChangeField = (field, changeFieldValue) => {
    changeFieldValue('field', field.value);
    changeFieldValue('label', this.getLabel(field));
  };

  renderConfig = (internalField, changeFieldValue, changeFieldError) => {
    const { unitFields, api,field} = this.props;
    return (
      <div className='Widget_Form_Config'>
        <InputText label='Label' required value={ api.getFieldsVerbiage(internalField, 'label')  }
                   onChange={ (v) => changeFieldValue('label', v) } error={ internalField.errors['label'] }
                   onError={ (error) => changeFieldError('label', error) }/>
        <InputSelect label='Select a field' value={ internalField.field }
                     onChange={ (v) => { this.handleChangeField(v, changeFieldValue); } }
                     options={ unitFields.map(item => {return { value: item.key, label: item.name };}) }/>
        <InputSelect label='Display Width' 
                    value={ internalField.display_width }
                    onChange={ (v) => changeFieldValue('display_width', v.value)
                    }
                    options={field.displayWidthOptions && field.displayWidthOptions.map((option) => {
                      return { value: option.value, label: option.value };
                    })}/>
        <div className="InputCheckboxesWrapper">
          <Checkbox onChange={ (v) => changeFieldValue('lockDDR', v) } label='Lock in DDR'
                    checked={ internalField.lockDDR }
                    className='InputCheckbox_Block'/>
          <Checkbox onChange={ (v) => changeFieldValue('force_line_break', v) } label='Start new line / row'
                    checked={ internalField.force_line_break }
                    className='InputCheckbox_Block'/>
          
        </div>
      </div>
    );
  };

  render() {
    const { field, renderForm, data, value, api } = this.props;
    const currencyField = field.config ? UnitOptions.getCurrencyFields().includes(field.config.field) : false;
    const dateField = field.config ? UnitOptions.getDateFields().includes(field.config.field) : false;
    let valueFormat = null;
    if (Utils.isNull(value)) {
      valueFormat = (Utils.isNull(data) ? null : ' - ');
    }
    else {
      valueFormat = value;
    }
    if (currencyField && Utils.isNumber(valueFormat)) {
      valueFormat = Utils.formatCurrency(valueFormat);
    }
    if (dateField && (moment(valueFormat).toDate().toString() !== 'Invalid Date')) {
      valueFormat = Utils.formatDateShow(moment(valueFormat).toDate())
    }
    const styleDescription = {
      color: ConfigService.getColor('secondaryColor'),
    };
    const props = {
      ...this.props,
      renderForm: () => renderForm(this.renderConfig),
      formTitle: 'Unit Field',
      className: 'WrapperWidget_Inline'
    };
    return (
      <WrapperWidget {...props} >
        <div className='UnitInfoWidget'>
          <div  className='Widget_Label'>
            <span className='Widget_Label_Description' style={ styleDescription }>{ valueFormat || (api ? api.getFieldsVerbiage(field, 'description') : field.description )}</span>
          </div>
        </div>
      </WrapperWidget>
    );
  }
}

export const UnitInfoWidgetEditable = withFieldActions(UnitInfoWidget);